import React from "react";
import { Card, Box, Typography } from "@mui/material";
import classes from "./WeatherCard.module.css";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import RainIcon from "../../../common/SvgIcons/RainIcon";
import DrizzleIcon from "../../../common/SvgIcons/Drizzle";
import CloudIcon from "../../../common/SvgIcons/Cloud";

const weatherEnum = {
  Clouds: "Oblačno",
  Rain: "Dážď",
  Snow: "Sneh",
  Clear: "Slnečno",
  Drizzle: "Mrholenie",
  Thunderstorm: "Búrka",
};

const iconEnum = {
  Clouds: <CloudIcon viewBox="0 0 1280.000000 1058.000000" />,
  Rain: <RainIcon viewBox="0 0 1280.000000 1058.000000" />,
  Snow: <AcUnitIcon />,
  Clear: <WbSunnyIcon />,
  Drizzle: <DrizzleIcon viewBox="0 0 1280.000000 1058.000000" />,
  Thunderstorm: <FlashOnIcon />,
};

const dayEnum = {
  1: "Pondelok",
  2: "Utorok",
  3: "Streda",
  4: "Štvrtok",
  5: "Piatok",
  6: "Sobota",
  0: "Nedeľa",
};

function WeatherCard(props) {
  const { temperature, dayInArray, text } = props;
  const icon =
    Object.keys(iconEnum).indexOf(text) === -1 ? (
      <WbSunnyIcon />
    ) : (
      iconEnum[text]
    );
  const weatherCondition =
    Object.keys(weatherEnum).indexOf(text) === -1
      ? "Slnečno"
      : weatherEnum[text];
  return (
    <Card className={classes.card}>
      <Box className={classes.textPart}>
        <Typography component="div" variant="h3">
          {dayEnum[(new Date().getDay() + dayInArray) % 7]}
        </Typography>
        <Typography component="div" className={classes.iconPart}>
          {icon}
        </Typography>
        <Typography
          variant="h3"
          component="div"
          className={classes.temperaturePart}
        >
          {Number(temperature.toFixed(1))}°C
        </Typography>
        <Typography
          component="div"
          variant="h4"
          sx={{ fontWeight: 300 }}
          className={classes.textWeatherPart}
        >
          {weatherCondition}
        </Typography>
      </Box>
    </Card>
  );
}

export default WeatherCard;
